// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inspector-appender {\n  width: 100%;\n  border: dashed 1px gray;\n  padding: 6px;\n  color: #555d66;\n  background-color: rgba(237, 239, 240, 0.8);\n  text-align: center;\n  cursor: pointer;\n}\n.inspector-appender:hover {\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
